<template>
  <BaseSlugPage :filters="filters" />
</template>

<script setup>
import BaseSlugPage from "~/nuxt_modules/blog/ui/components/BaseSlugPage.vue";
import { useBlogStore } from "~/nuxt_modules/blog/store/blog.store.js";

definePageMeta({
  key: "postsByCategory",
});

const route = useRoute();
const { isCategoryExist, getCategory } = useBlogStore();

if (!isCategoryExist(route.params.categorySlug)) {
  throw showError({
    statusCode: 404,
    statusMessage: "Such blog category doesn't exist",
  });
}

useSeoMeta({
  title: () => getCategory(route.params.categorySlug).metaTitle,
  description: () => getCategory(route.params.categorySlug).metaDescription,
});

const filters = computed(() => {
  return {
    category: {
      slug: route.params.categorySlug,
    },
  };
});
</script>

<style scoped lang="scss"></style>
